import {ValueObject} from '@s-ui/domain'

export class SubscribeToNewsletterRequest extends ValueObject {
  /**
   * @param {Object} param
   * @param {Number|String} param.email
   * @param {Number|String} param.userId
   * @param {Number|String} param.token
   */
}
